module.exports = __webpack_public_path__ + "../static/img/panoptico_mini.a667f6dd.png";